'use client'

import React from 'react'

import ProviderComposer from '../../elements/ProviderComposer'
import {ToolInfoProvider} from '../../../contexts/toolInfo'
import updateRecentUsedToolKey from '../../../app/utils/updateRecentUsedToolKey'


export default function ClientLayout({toolInfo, children}) {

  React.useEffect(() => {
    // 更新最近使用的工具
    updateRecentUsedToolKey(toolInfo.key)
  }, [toolInfo.key])

  return (
    <ProviderComposer providers={[
      ProviderComposer.provider(ToolInfoProvider, {toolInfo}),
    ]}>
      {children}
    </ProviderComposer>
  )
}